import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as IconCouple } from '../../media/icons/group.svg';
import { ReactComponent as IconLocation } from '../../media/icons/location.svg';
import { ReactComponent as IconLink } from '../../media/icons/arrow_right.svg';
import { ReactComponent as IconArrow } from '../../media/icons/arrow_right.svg';
import { ReactComponent as IconDetails } from '../../media/icons/details.svg';
import { format_price } from '../../functions/functions_formatting.js';


export default class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            data: []
        };
        this.updatePicture = this.updatePicture.bind(this);
    }


    componentDidMount() {
        if (this.state.data !== this.props.data) {
            this.setState({
                data: this.props.data
            });
        }
    }


    componentDidUpdate() {
        if (this.state.data !== this.props.data) {
            this.setState({
                data: this.props.data
            });
        }
    }


    updatePicture(trip_id, next = true) {
        var data = this.state.data;
        data.map(trip => {
            // Check if this is the trip
            if (trip.trip_id == trip_id) {
                var list = trip.pictures_all;
                if (next) {
                    list.push(list.shift());
                } else {
                    list.unshift(list.pop());
                }
                trip.pictures_all = list;
            }
        });
        this.setState({
            data: data
        })
    }


    render() {

        return (
            <div className="content-wrapper--wide">
                <div className="home__tripcarousel-container">
                    <h2 className="home__tripcarousel__title text-title">
                        {this.props.label}
                    </h2>
                    <div className="home__tripcarousel-wrapper">

                        {this.state.data && this.state.data.map((trip, index) => (
                            ((trip.pictures_all && trip.pictures_all.length >= 1 /* && trip.activities_count && trip.activities_count >= 1 */) &&
                                <div key={index} className="home__tripcarousel__element">
                                    {trip.collection && trip.collection.length >= 1 &&
                                        <div className="home__tripcarousel__element__labelbar">
                                            {trip.collection.slice(0, 3).map((element, i) => (
                                                <div key={i} className="home__tripcarousel__element__labelbar__label">
                                                    {element}
                                                </div>
                                            ))}
                                        </div>
                                    }
                                    <div className="tripcarousel__element__picture">
                                        {trip.pictures_all[0].filepath.endsWith(".mp4") ||
                                            trip.pictures_all[0].filepath.endsWith(".mov") ||
                                            trip.pictures_all[0].filepath.endsWith(".avi") ? (
                                            <video
                                                src={trip.pictures_all[0].filepath}
                                                alt={trip.pictures_all[0].label}
                                                className="tripcarousel__element__picture-inner"
                                                playsInline
                                                controls
                                                muted
                                                loop
                                                preload="auto"
                                            />
                                        ) : (
                                            <img
                                                src={trip.pictures_all[0].filepath}
                                                alt={trip.pictures_all[0].label}
                                                className="tripcarousel__element__picture-inner"
                                            />
                                        )}
                                        {trip.pictures_all && trip.pictures_all.length >= 2 &&
                                            <div onClick={() => this.updatePicture(trip.trip_id, false)} className="tripcarousel__element__picture__navbutton tripcarousel__element__picture__navbutton--left">
                                                <IconArrow className="tripcarousel__element__picture__navbutton-inner" />
                                            </div>
                                        }
                                        {trip.pictures_all && trip.pictures_all.length >= 2 &&
                                            <div onClick={() => this.updatePicture(trip.trip_id, true)} className="tripcarousel__element__picture__navbutton tripcarousel__element__picture__navbutton--right">
                                                <IconArrow className="tripcarousel__element__picture__navbutton-inner" />
                                            </div>
                                        }
                                    </div>
                                    <div className="tripcarousel__element__content">
                                        <div className="tripcarousel__element__contentbox tripcarousel__element__title">
                                            <Link to={"/trip/" + trip.trip_id} className="tripcarousel__element__title-inner text-bold">
                                                {trip.title}
                                            </Link>
                                        </div>
                                        {((trip.cities && trip.cities.length >= 1) || (trip.countries && trip.countries.length >= 1)) &&
                                            <div className="tripcarousel__element__contentbox tripcarousel__element__contentbox-flex">
                                                <div className="tripcarousel__element__contentbox__icon">
                                                    <IconLocation className="tripcarousel__element__contentbox__icon-inner" />
                                                </div>
                                                <div className="tripcarousel__element__contentbox__label tripcarousel__element__contentbox__label--doubleline">
                                                    {trip.cities && trip.cities.length >= 1 &&
                                                        <div className="tripcarousel__element__contentbox__label__element">
                                                            {trip.cities.length > 1
                                                                ? (trip.cities.join(" | "))
                                                                : (trip.cities[0])
                                                            }
                                                        </div>
                                                    }
                                                    {trip.countries && trip.countries.length >= 1 &&
                                                        <div className="tripcarousel__element__contentbox__label__element">
                                                            {trip.countries.length > 1
                                                                ? (trip.countries.join(" | "))
                                                                : (trip.countries[0])
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                        {(trip.target || trip.category) &&
                                            <div className="tripcarousel__element__contentbox tripcarousel__element__contentbox-flex">
                                                <div className="tripcarousel__element__contentbox__icon">
                                                    <IconCouple className="tripcarousel__element__contentbox__icon-inner tripcarousel__element__contentbox__icon-inner--large" />
                                                </div>
                                                <div className="tripcarousel__element__contentbox__label">
                                                    <div className="tripcarousel__element__contentbox__label__element">
                                                        {trip.target.concat(trip.category).join(" | ")}
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {(trip.activities_count && trip.activities_count >= 1) &&
                                            <div className="tripcarousel__element__contentbox tripcarousel__element__contentbox-flex">
                                                <div className="tripcarousel__element__contentbox__icon">
                                                    <IconDetails className="tripcarousel__element__contentbox__icon-inner" />
                                                </div>
                                                <div className="tripcarousel__element__contentbox__label">
                                                    {(trip.activities_count + " activities") + (trip.pricing ? " | " + trip.pricing[0] : "")}
                                                </div>
                                            </div>
                                        }
                                        <div className="tripcarousel__element__contentbox tripcarousel__element__title">
                                            {trip.settings.paid && trip.settings.price && trip.settings.price > 0 &&
                                                <div className="tripcarousel__element__title-inner text-bold">
                                                    {format_price(parseInt(trip.settings.price))}
                                                </div>
                                            }
                                            {!(trip.settings.paid && trip.settings.price && trip.settings.price > 0) &&
                                                <div className="tripcarousel__element__title-inner text-bold text-color-primary">
                                                    {"Free"}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            )
                        ))}


                        {(!this.state.data || this.state.data.length <= 0) && [0, 1, 2, 3, 4, 5].map((index) => (
                            <div key={index} className="home__tripcarousel__element home__tripcarousel__element--skeleton"></div>
                        ))}


                        <Link to={this.props.link} className="home__tripcarousel__link-container">
                            <div className="home__tripcarousel__link__label">
                                See all
                            </div>
                            <IconLink className="home__tripcarousel__link__icon" />
                        </Link>

                    </div>
                </div>
            </div>
        )
    }
}
